import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NgxNavbarModule } from 'ngx-bootstrap-navbar';
import { PropertiesComponent } from './properties/properties.component';
import { UsComponent } from './us/us.component';
import { PartnersComponent } from './partners/partners.component';
import { BenefitsComponent } from './benefits/benefits.component';
import { EventsComponent } from './events/events.component';
import { PropertyDetailsComponent } from './property-details/property-details.component';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

import { SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { CoreDirectivesModule } from '@core/directives/directives';

import { QuillModule } from 'ngx-quill';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CoreSidebarModule } from '@core/components';
import { CalendarMainSidebarComponent } from 'app/main/pages/landing/events/calendar-main-sidebar/calendar-main-sidebar.component';
import { NgxMaskModule } from 'ngx-mask';
import { HeaderDetailPropertyComponent } from './header-detail-property/header-detail-property.component';
import { MesaDirectivaComponent } from './mesa-directiva/mesa-directiva.component';
import { AffiliatesComponent } from './affiliates/affiliates.component';
import { SponsorsComponent } from './sponsors/sponsors.component';
// swiper configuration
import { SwiperModule } from 'ngx-swiper-wrapper';
import { ShareButtonModule } from 'ngx-sharebuttons/button';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { GrupoSociosComponent } from './grupo-socios/grupo-socios.component';
import { GrupoBeneficiosComponent } from './grupo-beneficios/grupo-beneficios.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

FullCalendarModule.registerPlugins([dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]);

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: 'property/:id',
    component: PropertyDetailsComponent
  },
];

@NgModule({
  declarations: [
    HomeComponent,
    FooterComponent,
    HeaderComponent,
    PropertiesComponent,
    UsComponent,
    PartnersComponent,
    BenefitsComponent,
    EventsComponent,
    PropertyDetailsComponent,
    CalendarMainSidebarComponent,
    HeaderDetailPropertyComponent,
    MesaDirectivaComponent,
    AffiliatesComponent,
    SponsorsComponent,
    GrupoSociosComponent,
    GrupoBeneficiosComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CardSnippetModule,
    ContentHeaderModule,
    NgxNavbarModule,
    ShareButtonModule,
    NgxPageScrollCoreModule.forRoot({ duration: 800, scrollOffset: 150 }),
    ShareIconsModule,
    CoreDirectivesModule,
    QuillModule.forRoot(),
    CoreSidebarModule,
    FullCalendarModule,
    SwiperModule,
    NgxMaskModule.forRoot(),
  ]
})
export class LandingModule { }
